import React, { useState } from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { useSelector } from "react-redux";

const professionalFilter = {
  $and: [
    {
      $or: [
        { professional_role_id: 1 },
        { professional_role_id: 2 },
        { professional_role_id: 3 },
        { professional_role_id: 4 },
      ],
    },
    { $or: [{ status: 1 }, { status: 3 }] },
    {
      controller: {
        $neq: true,
      },
    },
  ],
};

const controllerFilter = {
  $and: [{ controller: true }, { $or: [{ status: 1 }, { status: 3 }] }],
};

const SettingsForm = (props) => {
  const { changedValues } = props;
  const [strategy, setStrategy] = useState(null);
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );

  const onChange = (e) => {
    setStrategy(e.target.value);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={
            <FormattedMessage id="app.house_visit_settings.auditorSettings" />
          }
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <EmployeesSelect
                  name="professional_employee_id"
                  category="patient.house_visit_settings"
                  waitForFetch={!activePatient || !activePatient.branch}
                  extraParams={{
                    scopePrefix: `branches/${activePatient.branch}/`,
                    filter: professionalFilter,
                  }}
                  required={strategy !== "controller"}
                  proffesional={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <EmployeesSelect
                  name="controller_employee_id"
                  category="patient.house_visit_settings"
                  waitForFetch={!activePatient || !activePatient.branch}
                  extraParams={{
                    scopePrefix: `branches/${activePatient.branch}/`,
                    filter: controllerFilter,
                  }}
                  required={
                    strategy === "controller" || strategy === "alternate"
                  }
                  proffesional={true}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ display: "flex", flex: 1 }}>
                <RadioButtonItem
                  name="visits_strategy"
                  category="patient.house_visit_settings"
                  visitsStrategy={true}
                  translated={true}
                  required={true}
                  onChange={onChange}
                />
              </div>
              <div style={{ flex: 1 }}>
                <CheckBoxItem
                  showLabel={true}
                  name="organization_default"
                  category="user"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ display: "flex", flex: 1 }}>
                <InputItem
                  name="months_between_visits"
                  category="patient.house_visit_settings"
                  number={true}
                  required={!changedValues.organization_default}
                  disabled={changedValues.organization_default}
                />
              </div>
              <div style={{ flex: 1 }}>
                <CheckBoxItem
                  showLabel={true}
                  name="active"
                  category="patient.house_visit_settings"
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
      <Spacer vertical={true} />
    </div>
  );
};

export default SettingsForm;
